import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel,Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';
import { EinvoiceDiscrepanciesReportContainerModel } from '../../../../../models/aggregates/e-invoice/my-einvoice_discrepancies_report_container.model';
import { GenericDocContainerModel} from '../../../../../models/aggregates/generic_doc';
import { MyEInvoiceToIrbContainerContainerModel } from '../../../../../models/aggregates/e-invoice/my-einvoice-to-irb-hdr-container.model';

// core2/tnt/dm/erp/e-invoice/reports/discrepancies-report/to-irb/backoffice-ep

@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceDiscrepanciesMonthlyReportService extends BaseApiTemplateService<EinvoiceDiscrepanciesReportContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports';
    this.httpClient = http;
  }

  public downloadDiscrepanciesReport(einvoiceDiscrepanciesReportContainerModel: EinvoiceDiscrepanciesReportContainerModel, visa: ApiVisa,): Observable<Blob> {
    const url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports/discrepancies-report/xls/backoffice-ep';
    return this.httpClient.post<Blob>(
      url, einvoiceDiscrepanciesReportContainerModel,
      this.getHttpHeaderBlob(visa)
    );
  }

  public webDiscrepanciesReport(einvoiceDiscrepanciesReportContainerModel: EinvoiceDiscrepanciesReportContainerModel, visa: ApiVisa,): Observable<EinvoiceDiscrepanciesReportContainerModel> {
    const url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports/discrepancies-report/web/backoffice-ep';
    return this.httpClient.post<EinvoiceDiscrepanciesReportContainerModel>(
      url, einvoiceDiscrepanciesReportContainerModel,
      this.getHttpHeader(visa)
    );
  }
  public getReportDetailsOfGenDoc(lineGuid: string,visa: ApiVisa): Observable<ApiResponseModel<GenericDocContainerModel>> {
    const url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports/discrepancies-report/gen-doc/backoffice-ep'+ `/${lineGuid}`;
    return this.httpClient.get<ApiResponseModel<GenericDocContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getReportDetailsOfToIRb(lineGuid: string, visa: ApiVisa,): Observable<ApiResponseModel<MyEInvoiceToIrbContainerContainerModel>> {
    const url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports/discrepancies-report/to-irb/backoffice-ep'+ `/${lineGuid}`;
    return this.httpClient.get<ApiResponseModel<MyEInvoiceToIrbContainerContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }
  public downloadReportDetailsOfGenDoc(lineGuid: string, visa: ApiVisa,): Observable<Blob> {
    const url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports/discrepancies-report/xls/gen-doc/backoffice-ep'+ `/${lineGuid}`;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(visa)
    );
  }
  public downloadReportDetailsOfToIRb(lineGuid: string, visa: ApiVisa,): Observable<Blob> {
    const url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports/discrepancies-report/xls/to-irb/backoffice-ep'+ `/${lineGuid}`;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(visa)
    );
  }
  public getReportDetailsOfGenDocQuery(pagination: Pagination,lineGuid: string,visa: ApiVisa): Observable<ApiResponseModel<GenericDocContainerModel>> {
      const urlPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports/discrepancies-report/gen-doc/backoffice-ep' 
      if (visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + urlPath;
      }
      const UrlByCriteria =
        this.apiUrl +'/'+ lineGuid + '/query?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
  }

  public getReportDetailsOfToIRbQuery(pagination: Pagination,lineGuid: string,visa: ApiVisa): Observable<ApiResponseModel<MyEInvoiceToIrbContainerContainerModel>> {
      const urlPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'reports/discrepancies-report/to-irb/backoffice-ep' 
      if (visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + urlPath;
      }
      const UrlByCriteria =
        this.apiUrl +'/'+ lineGuid + '/query?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<MyEInvoiceToIrbContainerContainerModel>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
  }
}
